import React, { useEffect, useState, useCallback } from 'react';
import PouchDB from 'pouchdb-browser';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { urls } from '../router/urls';
import { Link } from 'react-router-dom';
import Star from '../ui/Stars';
import Comment from '../comment/Comment';
import GroupElement from '../group_list_element/GroupElement';
import DistillationDescription from '../distillation_description/DistillationDescription';
import ChronologyDescription from '../chronology_description/ChronologyDescription';
import ShareResourceModal from '../ui/ShareResourceModal';
import { addView } from '../functions/functions';

const GroupDownloadedDescription = ({
  match: {
    params: { id }
  }
}) => {
  const { t, i18n } = useTranslation();
  const db = PouchDB('gestor_contenidos_db');
  const db_agrupacion = PouchDB('gestor_contenidos_agrupaciones');
  const [datos, setData] = useState({});
  const [datosAgrupacion, setDatosAgrupacion] = useState({});
  const [numPaginas, setNumPaginas] = useState(0);
  const [recursosPagina, setRecursosPagina] = useState([]);

  const getData = useCallback(() => {
    db.get(id)
      .then(doc => {
        setData(doc);
      })
      .catch(err => {
        if (err === 'not_found') {
          console.log(false);
        }
      });
  }, [db, id, setData]);

  const getGroupData = useCallback(() => {
    db_agrupacion
      .get(id)
      .then(doc => {
        setDatosAgrupacion(doc);
        setNumPaginas(Math.ceil(doc.group.grouping_resources.length / 5));
      })
      .catch(err => {
        if (err === 'not_found') {
          console.log(false);
        }
      });
  }, [db_agrupacion, id, setDatosAgrupacion, setNumPaginas]);

  const cambioPagina = d => {
    let selected = d.selected;
    let aux_data = datosAgrupacion.group.grouping_resources.slice(
      selected * 5,
      (selected + 1) * 5
    );
    setRecursosPagina(aux_data);
  };

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('lang'));
    getData();
    getGroupData();
    addView(id);
  }, [getData, getGroupData, i18n, id]);

  return (
    <div>
      <div
        style={{ backgroundColor: '#FAC600', width: '100%', height: '12px' }}
      >
        {' '}
      </div>

      {datos.object && datosAgrupacion.group ? (
        <>
          {/* Miga de pan */}
          <ol className="breadcrumb m-0">
            <li className="breadcrumb-item">
              <Link to="/" className="bc-link" title={t('inicio')}>
                <i className="fal fa-home"> </i>
                <span> {t('catalogo')}</span>
              </Link>
            </li>

            <li className="breadcrumb-item">
              <Link
                to={'/' + urls.descargas_agrupaciones}
                className="bc-link"
                title={'dashboard'}
              >
                <i className="fal fa-archive"> </i>
                <span> {t('header_agrupaciones')}</span>
              </Link>
            </li>

            <li className="breadcrumb-item active">
              <span>{datos.object.general.title.value}</span>
            </li>
          </ol>

          <div className="d-flex row" style={{ padding: '0px 30px 15px 30px' }}>
            <img
              alt={''}
              src={process.env.PUBLIC_URL + '/img/colecciones.png'}
              style={{
                width: '-webkit-fill-available',
                maxHeight: '281px',
                maxWidth: '581px'
              }}
            />
          </div>

          <div className="row">
            <span className="resources-title object-title-pwa">
              {datos.object.general.title.value}
            </span>
          </div>

          <div className="row options">
            <span className="titles-pwa">
              {datosAgrupacion.group.grouping_resources
                ? `${datosAgrupacion.group.grouping_resources.length} Recursos en esta colección`
                : ''}
            </span>
          </div>

          <div className={'row options'}>
            <div className="col-sm-4 col-12">
              <div className={'mb-3 d-inline stars-icon-pwa'}>
                <Star rating={datos.object.average_ranking} />
                <span className="stars-pwa fw-900 text-blue">
                  {datos.object.average_ranking + '.0'}
                </span>
              </div>
            </div>
            <div className="col-sm-4 col-auto options-pwa link-calificacion">
              <button
                className="options-pwa"
                onClick={() => window.open(urls.url_api + urls.visualizacion_recurso + id, "_blank")}
                rel="noopener noreferrer"
              >
                <span>{t('califica_recurso')} </span>
              </button>
              <i className={'fal fa-angle-right'}> </i>
            </div>
            <div className="col-sm-4 col-auto link-calificacion">
              <a
                href='/'
                className="options-pwa"
                data-toggle="modal"
                data-target=".modal-valoration"
              >
                <span>
                  {datos.object.annotation.length} {t('comentario')}{' '}
                </span>
              </a>
              <i className={'fal fa-angle-right'}> </i>
            </div>
          </div>

          <div
            className={'row options demo icon-pwa'}
            style={{ marginBottom: '0 0 6px 5px !important' }}
          >
            {/* boton favoritos */}
            <div
              className="d-inline show"
              data-toggle="tooltip"
              title=""
              data-original-title={t('agregar_favoritos')}
              aria-describedby="tooltip157034"
            >
              <button
                data-toggle="dropdown"
                className="btn btn-outline-default btn-lg btn-icon rounded-circle waves-effect waves-themed btn-favorites"
              >
                <i className="fas fa-heart"> </i>
              </button>

              <div
                className="dropdown-menu dropdown-md p-4"
                x-placement="bottom-start"
                style={{
                  position: 'absolute',
                  willChange: 'top, left',
                  top: '442px',
                  left: ' 24px'
                }}
              >
                <p className="dropdown-option ff-ws">
                  <a
                    className="link-favorite"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={urls.url_api + urls.agregar_favoritos + id + '/'}
                  >
                    {t('ingresar_colombia_aprende')}{' '}
                    <span className="fw-500">{t('colombia_aprende')}</span>.
                    <button className="btn btn-outline-info btn-pills btn-block waves-effect waves-themed mt-2">
                      {t('iniciar_sesion_registro')}
                    </button>
                  </a>
                </p>
              </div>
            </div>

            {/* boton opciones */}

            <div
              className="d-inline show"
              data-toggle="tooltip"
              title=""
              data-original-title={t('opciones')}
              aria-describedby="tooltip366550"
            >
              <button
                data-toggle="dropdown"
                className="btn btn-outline-default btn-lg btn-icon rounded-circle waves-effect waves-themed link-share"
              >
                <i className="fas fa-ellipsis-h"> </i>
              </button>

              <div
                className="dropdown-menu dropdown-md p-4"
                x-placement="bottom-start"
                style={{
                  position: 'absolute',
                  willChange: 'top, left',
                  top: '442px',
                  left: ' 24px'
                }}
              >
                <p className="dropdown-option ff-ws">
                  <a
                    className="link-favorite"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={urls.url_api + urls.agregar_favoritos + id + '/'}
                  >
                    {t('ingresar_colombia_aprende')}{' '}
                    <span className="fw-500">{t('colombia_aprende')}</span>.
                    <button className="btn btn-outline-info btn-pills btn-block waves-effect waves-themed mt-2">
                      {t('iniciar_sesion_registro')}
                    </button>
                  </a>
                </p>
              </div>
            </div>

            <button
              className="btn btn-outline-default btn-lg btn-icon rounded-circle waves-effect waves-themed"
              data-toggle="modal"
              data-target="#modal-shortcut"
            >
              <i className="far fa-share-alt"> </i>
            </button>
          </div>

          <ShareResourceModal
            resource_id={id}
            url={urls.url_api + datos.object.url}
            quote={datos.object.general.title.value}
          />

          <div className="row options">
            <h5 className="info-pwa">
              {t('descripcion')}
              <small className="mb-0">
                {datos.object.general.description[0].value}
              </small>
            </h5>
          </div>

          {/* grafico */}

          <div className="row grafica-pwa">
            <img
              src={process.env.PUBLIC_URL + '/img/grafica-b.png'}
              alt="logo"
              aria-roledescription="logo"
            />
          </div>

          {/* Palabras Clave */}

          <div className="row options">
            <h1 className="titles-pwa">
              <div className="mb-3">{t('palabra_clave')}</div>
              {datos.object.general.keyword[0].value.map((elemento, index) => {
                return (
                  <span
                    className="keyword badge badge-light badge-pill ff-rb"
                    key={index}
                  >
                    {elemento}
                  </span>
                );
              })}
            </h1>
          </div>

          {/* Listado */}
          <div className="row">
            <span className="listado-title object-title-pwa">
              {' '}
              Listado de{' '}
              {datosAgrupacion.group.grouping_resources
                ? datosAgrupacion.group.grouping_resources.length
                : ''}{' '}
              recursos
            </span>
          </div>

          {/* modal comentarios*/}

          <div
            className="modal fade modal-backdrop-transparent modal-valoration"
            aria-modal="true"
            style={{ paddingRight: '15px' }}
          >
            <div className="modal-dialog modal-dialog-right modal-md">
              <div className="modal-content">
                <div className="dropdown-header d-flex justify-content-between align-items-center w-100">
                  <h4 className="m-0 text-secondary font-weight-bold py-3 roboto-pwa">
                    {t('comentario')} (
                    {datos['id'] ? datos['annotation'].length : '0'})
                  </h4>
                  <button
                    type="button"
                    className="close text-secondary position-absolute pos-top pos-right p-2 m-1 mr-2 py-3"
                    data-dismiss="modal"
                  >
                    <span>
                      <i className="fal fa-times"> </i>
                    </span>
                  </button>
                </div>
                <div className="modal-body p-0">
                  <div className="settings-panel">
                    {/*cuando se carga el recurso verificar si tiene comentarios*/
                    datos.object.annotation.length ? (
                      datos.object.annotation.map((element, index) => {
                        return (
                          <Comment
                            key={index}
                            stars={element.get_rating}
                            time={element.human_date}
                            description={element.description.value}
                            username={element.user_name}
                          />
                        );
                      })
                    ) : (
                      <h4
                        id="reviewMessage"
                        className="text-center text-secondary fw-500 py-4"
                      >
                        {t('no_comentarios')}
                      </h4>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {datosAgrupacion.group.grouping_resources ? (
            datos.object.group_type === 'Agregación' ? (
              <>
                {recursosPagina.map((elemento, index) => {
                  return (
                    <GroupElement
                      key={index}
                      is_group={elemento['group_type']}
                      stars={elemento['qualification']}
                      taxon={elemento['taxon_path']}
                      descripcion={elemento['description']}
                      nombre={elemento['title']}
                      format={elemento['technical_format']}
                      id={elemento['resource_grouped']}
                      structured_group_data={elemento['structured_group_data']}
                    >
                      {' '}
                    </GroupElement>
                  );
                })}

                {/* paginacion en colecciones*/}
                <div className="row options-between tab-content">
                  <ReactPaginate
                    previousLabel={'«'}
                    nextLabel={'»'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={numPaginas}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={cambioPagina}
                    containerClassName={'pagination my-4'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName={'page-link'}
                    pageClassName={'page-item'}
                    previousClassName={'page-item'}
                    nextClassName={'page-item'}
                    previousLinkClassName={'page-link'}
                    nextLinkClassName={'page-link'}
                    initialPage={0}
                  />
                </div>
              </>
            ) : datosAgrupacion.group.group_type === 'Destilación' ? (
              <DistillationDescription
                data={datosAgrupacion.group.grouping_resources}
              />
            ) : datosAgrupacion.group.group_type === 'Cronología' ? (
              <ChronologyDescription data={datosAgrupacion} />
            ) : (
              ''
            )
          ) : (
            ''
          )}
        </>
      ) : (
        ''
      )}
    </div>
  );
};

export default GroupDownloadedDescription;
